module.exports = __webpack_public_path__ + "static/iett1-106840aea47d7417ed53057c339f0e17.png";